var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dropShadowSoft",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 3,
    floodColor: "#000",
    floodOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropShadowSoft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 32L16 16H48L56 32H40L36 36H28L24 32H8Z",
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32H24L28 36H36L40 32H56V48C56 50.2 54.2 52 52 52H12C9.8 52 8 50.2 8 48V32Z",
    fill: "#F2F2F2",
    stroke: "#CFCFCF",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.5c0ebc6878afadb1e93e1e7fc50f8d0a.svg";
export { ForwardRef as ReactComponent };